import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function PricingCards() {
  return <section id="planes" className="py-20 px-4 bg-stone-50" data-id="element-241">
      <div className="max-w-5xl mx-auto" data-id="element-242">
        <h2 className="text-3xl md:text-4xl font-black text-center text-stone-900 mb-12" data-id="element-243">
          ELEGÍ TU MEGAPACK
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-244">
          {/* Tier 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 border border-stone-200 shadow-sm flex flex-col" data-id="element-245">
            <div className="text-4xl mb-4" data-id="element-246">📘</div>
            <h3 className="text-2xl font-black text-stone-900 mb-2" data-id="element-247">
              MEGAPACK: NO COLAPSAR EN EL MEP
            </h3>
            <p className="text-brand-600 font-bold mb-4" data-id="element-248">6 Tomos + 6 Bonos</p>
            <p className="text-sm text-stone-500 mb-8 pb-8 border-b border-stone-100" data-id="element-249">
              Ideal para: Docentes de primaria y secundaria del MEP
            </p>

            <div className="mb-8" data-id="element-250">
              <span className="text-stone-400 line-through text-xl block mb-1" data-id="element-251">
                $47 USD
              </span>
              <div className="flex items-baseline gap-1" data-id="element-252">
                <span className="text-5xl font-black text-stone-900" data-id="element-253">
                  $13.99
                </span>
                <span className="text-stone-500 font-medium" data-id="element-254">USD</span>
              </div>
            </div>

            <a href="https://reconectacontigohoy.com/checkouts/cn/hWNEAaRqar5efqxLJ1foiMU6/es-cr?_r=AQABVFTtdz6nBqEj_-ITAOeGUo6Ah7_cs69ZZU0ItEuInME&cart_link_id=Yb9f0kdY&preview_theme_id=151921262765" target="_blank" rel="noopener noreferrer" className="mt-auto block w-full py-4 px-6 text-center font-bold text-brand-700 bg-brand-50 border-2 border-brand-200 hover:bg-brand-100 rounded-xl transition-colors" data-id="element-255">
              → QUIERO MI MEGAPACK AHORA
            </a>
          </motion.div>

          {/* Tier 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-brand-900 rounded-3xl p-8 border-2 border-accent-500 shadow-2xl flex flex-col relative transform md:-translate-y-4" data-id="element-256">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent-500 text-white text-xs font-bold uppercase tracking-wider py-1 px-4 rounded-full flex items-center gap-1 shadow-lg" data-id="element-257">
              <Star className="w-3 h-3 fill-current" data-id="element-258" /> Recomendado
            </div>

            <div className="text-4xl mb-4" data-id="element-259">🏆</div>
            <h3 className="text-2xl font-black text-white mb-2" data-id="element-260">
              MEGAPACK + DOCENTE MEMORABLE ⭐
            </h3>
            <p className="text-accent-400 font-bold mb-4" data-id="element-261">
              6 Tomos + 6 Bonos + Sistema de Pedagogía de Alto Impacto
            </p>
            <p className="text-sm text-brand-200 mb-8 pb-8 border-b border-brand-800" data-id="element-262">
              Ideal para: Docentes que quieren impacto real además de
              supervivencia
            </p>

            <div className="mb-8" data-id="element-263">
              <span className="text-brand-400 line-through text-xl block mb-1" data-id="element-264">
                $67 USD
              </span>
              <div className="flex items-baseline gap-1" data-id="element-265">
                <span className="text-5xl font-black text-white" data-id="element-266">$19.99</span>
                <span className="text-brand-200 font-medium" data-id="element-267">USD</span>
              </div>
            </div>

            <a href="https://reconectacontigohoy.com/checkouts/cn/hWNEAawhQdPQHHWbnZeyr4q2/es-cr?_r=AQABFOg9s6RtaukgDYdYeARgz85DpAvUzaSQD6K5iWKvLFk&cart_link_id=ajKw4Caz&preview_theme_id=151921262765" target="_blank" rel="noopener noreferrer" className="mt-auto block w-full py-4 px-6 text-center font-bold text-white bg-accent-500 hover:bg-accent-600 rounded-xl shadow-[0_0_20px_rgba(16,185,129,0.45)] transition-all hover:scale-105 active:scale-95" data-id="element-268">
              → QUIERO EL MEGAPACK + DOCENTE MEMORABLE
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}